import React, { Component } from "react";

const defaultButton = props => (
  <button type="button" {...props} className="btn semi-bold">
    {props.children}
  </button>
);

export default class ReactTablePagination extends Component {
  constructor(props) {
    super();
    this.state = {
      page: props.page
    };
  }

  componentWillReceiveProps(nextProps) {
    this.setState({ page: nextProps.page });
  }

  getSafePage = page => {
    if (isNaN(page)) page = this.props.page;
    if (this.props.canNextFromData) return page;
    return Math.min(Math.max(page, 0), this.props.pages - 1);
  };

  changePage = page => {
    page = this.getSafePage(page);
    this.setState({ page });
    if (this.props.page !== page) this.props.onPageChange(page);
  };

  applyPage = e => {
    if (e) e.preventDefault();
    const page = this.state.page;
    this.changePage(page === "" ? this.props.page : page);
  };

  render() {
    const {
      pages,
      page,
      showPageSizeOptions,
      pageSizeOptions,
      pageSize,
      data,
      canPrevious,
      onPageSizeChange,
      FirstComponent = defaultButton,
      PreviousComponent = defaultButton,
      NextComponent = defaultButton,
      LastComponent = defaultButton
    } = this.props;

    const canNext = this.props.canNextFromData
      ? data && data.length === pageSize
      : this.props.canNext;

    const range = 5;

    const start = page + 1 + range < pages ? page + 1 : pages - range;

    let btns = [];
    for (let index = start; index <= start + range; index++) {
      if (index > 0)
        btns.push(
          <button
            key={index}
            className={
              page + 1 === index ? "btn semi-bold active" : "btn semi-bold"
            }
            onClick={() => {
              this.changePage(index - 1);
            }}
          >
            {index}
          </button>
        );
    }

    return (
      <>
        {data.length ? (
          <div className="pagination-wrpr semi-bold">
            <div className="container">
              <div className="pull-left flex-wrpr">
                <span className="showing-wrpr">
                  Showing {Number(page) * Number(pageSize) + 1} to{" "}
                  {Number(page + 1) * Number(pageSize) < data.length
                    ? Number(page + 1) * Number(pageSize)
                    : data.length}{" "}
                  of {data.length} rows per page
                </span>
                {showPageSizeOptions && (
                  <span className="select-wrap">
                    <select
                      className="semi-bold"
                      onChange={e => onPageSizeChange(Number(e.target.value))}
                      value={pageSize}
                    >
                      {pageSizeOptions.map((option, i) => (
                        <option key={i} value={option}>
                          {option} {this.props.rowsText}
                        </option>
                      ))}
                    </select>
                  </span>
                )}
              </div>
              <div className="pull-right flex-wrpr">
                <FirstComponent
                  onClick={() => {
                    if (!canPrevious) return;
                    this.changePage(0);
                  }}
                  disabled={!canPrevious}
                >
                  First
                </FirstComponent>
                <PreviousComponent
                  onClick={() => {
                    if (!canPrevious) return;
                    this.changePage(page - 1);
                  }}
                  disabled={!canPrevious}
                >
                  <i className="icon icon-ic-pagination-left" />
                </PreviousComponent>
                <div className="pagi-links">{btns}</div>
                <NextComponent
                  onClick={() => {
                    if (!canNext) return;
                    this.changePage(page + 1);
                  }}
                  disabled={!canNext}
                >
                  <i className="icon icon-ic-pagination-right" />
                </NextComponent>
                <LastComponent
                  onClick={() => {
                    if (!canNext) return;
                    this.changePage(pages);
                  }}
                  disabled={!canNext}
                >
                  Last
                </LastComponent>
              </div>
            </div>
          </div>
        ) : null}
      </>
    );
  }
}
